(() => {
  const $=(s,r=document)=>r.querySelector(s), $$=(s,r=document)=>[...r.querySelectorAll(s)];
  const KEY='px-reservation-cart-v2';
  const esc=s=>String(s??'').replace(/[&<>"]/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]));
  const money=c=>'$'+((+c||0)/100).toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2});
  const imgW=(src,w)=>!src?'':(src.startsWith('//')?'https:'+src:src)+(src.includes('?')?'&':'?')+'width='+w;
  const read=()=>{try{const x=JSON.parse(localStorage.getItem(KEY)||'[]');return Array.isArray(x)?x:[]}catch(_){return[]}};
  const save=x=>{try{localStorage.setItem(KEY,JSON.stringify(x))}catch(_){}};
  const slug=s=>String(s||'').toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'').slice(0,55);
  let items=read();
  const PENDING='px-reservation-pending-v1', RECEIPT='px-reservation-receipt-v1';
  const stored=(storage,key)=>{try{return JSON.parse(storage.getItem(key)||'null')}catch(_){return null}};
  let receipt=stored(localStorage,RECEIPT);
  function showReceipt(){
    const d=$('[data-res-cart]'); if(!d)return;
    const ok=$('[data-res-success]',d),wrap=$('[data-res-form-wrap]',d),lines=$('[data-res-receipt]',d);
    const show=!!receipt && items.length===0;
    if(ok)ok.hidden=!show; if(wrap)wrap.hidden=show;
    if(lines && show)lines.innerHTML=(receipt.items||[]).map(x=>`<p>${esc(x.name)} · ${esc(x.logo||'Standard')} · ${esc(x.color)} · ${esc(x.size)} · Qty ${+x.qty||1}</p>`).join('');
  }
  let returnFocus=null;
  const key=x=>[x.handle,x.logo,x.color,x.size].join('|');
  const count=()=>items.reduce((n,x)=>n+(+x.qty||1),0);
  const total=()=>items.reduce((n,x)=>n+(+x.price||0)*(+x.qty||1),0);
  let submissionId='';
  const tags=()=>['newsletter','phoenx-launch','phoenx-reservation',...items.map((x,i)=>('pxr'+(i+1)+'-'+slug(x.name)+'-'+slug(x.logo||'standard')+'-'+slug(x.color)+'-'+slug(x.size)+'-q'+(+x.qty||1)+(submissionId?'-r'+submissionId:'')).slice(0,240))].join(',');

  function open(){
    const d=$('[data-res-cart]'); if(!d)return;
    if(d.hidden)returnFocus=document.activeElement;
    render(); showReceipt();
    d.hidden=false; d.setAttribute('aria-hidden','false'); document.documentElement.classList.add('res-open');
    if (!(history.state && history.state.pxReserve)) {
      try { history.pushState({ ...(history.state || {}), pxReserve: true }, '', location.href) } catch (_) {}
    }
    setTimeout(()=>{const c=$('[data-res-close]',d);c&&c.focus()},20);
  }
  function resetSuccess(){
    receipt=null; try{localStorage.removeItem(RECEIPT)}catch(_){}
    const d=$('[data-res-cart]'); if(!d)return;
    const ok=$('[data-res-success]',d), wrap=$('[data-res-form-wrap]',d);
    if(ok && !ok.hidden){
      ok.hidden=true;
      if(wrap) wrap.hidden=false;
      d.dataset.success='false';
    }
  }
  function close(useHistory=false){
    const d=$('[data-res-cart]'); if(!d)return;
    if(d.hidden)return;
    const rewind=useHistory && history.state && history.state.pxReserve;
    d.hidden=true; d.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('res-open');
    if(returnFocus && returnFocus.isConnected)returnFocus.focus();
    if(rewind)history.back();
  }
  function render(){
    $$('[data-res-count]').forEach(x=>x.textContent=count());
    const d=$('[data-res-cart]'); if(!d)return;
    const lines=$('[data-res-lines]',d), empty=$('[data-res-empty]',d), sum=$('[data-res-summary]',d), submit=$('[data-res-submit]',d), tag=$('[data-res-tags]',d);
    if(lines) lines.innerHTML=items.map((x,i)=>`
      <article class="res-line">
        <div class="res-thumb">${x.image?`<img src="${esc(imgW(x.image,220))}" alt="">`:''}</div>
        <div class="res-line-copy">
          <h3>${esc(x.name)}</h3>
          <p>${x.logo?esc(x.logo)+' · ':''}${esc(x.color)} · ${esc(x.size)}</p>
          <span>${money(x.price)}</span>
          <div class="res-qty">
            <button type="button" data-res-minus="${i}" aria-label="Decrease quantity">−</button>
            <b>${x.qty}</b>
            <button type="button" data-res-plus="${i}" aria-label="Increase quantity">+</button>
            <button type="button" class="res-remove" data-res-remove="${i}">Remove</button>
          </div>
        </div>
      </article>`).join('');
    if(empty) empty.hidden=!!items.length;
    if(sum) sum.innerHTML=items.length?`<span>Estimated order total</span><b>${money(total())}</b>`:'';
    if(submit) submit.disabled=!items.length;
    if(tag) tag.value=tags();
    const contact=$('.res-contact',d); if(contact)contact.hidden=!items.length;
    if(lines)lines.hidden=!items.length; if(sum)sum.hidden=!items.length;
  }
  function add(x){
    resetSuccess();
    const hit=items.find(y=>key(y)===key(x));
    if(hit) hit.qty=Math.min(10,(+hit.qty||1)+1);
    else items.push({...x,qty:1});
    save(items); render(); open();
  }
  document.addEventListener('px:reserve-add',e=>add(e.detail||{}));
  document.addEventListener('click',e=>{
    const more=e.target.closest('[data-res-more]');
    if(more){
      e.preventDefault();
      close(false);
      const productClose=$('#pd .close'); if(productClose)productClose.click();
      location.assign(more.href);
      return;
    }
    if(e.target.closest('[data-res-open]')){e.preventDefault();open();return}
    if(e.target.closest('[data-res-close],[data-res-backdrop]')){close(true);return}
    const m=e.target.closest('[data-res-minus]'); if(m){const i=+m.dataset.resMinus;if(items[i])items[i].qty=Math.max(1,items[i].qty-1);save(items);render();return}
    const p=e.target.closest('[data-res-plus]'); if(p){const i=+p.dataset.resPlus;if(items[i])items[i].qty=Math.min(10,items[i].qty+1);save(items);render();return}
    const r=e.target.closest('[data-res-remove]'); if(r){items.splice(+r.dataset.resRemove,1);save(items);render();return}
  });
  addEventListener('keydown',e=>{if(e.key==='Escape')close(true)});
  addEventListener('popstate',()=>{
    const d=$('[data-res-cart]');
    if(d && !d.hidden && !(history.state && history.state.pxReserve)) close(false);
  });

  const d=$('[data-res-cart]');
  if(d){
    render();
    const params=new URLSearchParams(location.search), pending=stored(sessionStorage,PENDING);
    const reservationReturn = params.get('reservation_submitted')==='1' || location.hash==='#px-reservation-form' || params.get('customer_posted')==='true';
    const acknowledged=d.dataset.success==='true' || params.get('customer_posted')==='true' || params.get('reservation_submitted')==='1';
    if(pending && Date.now()-pending.time<30*60*1000 && d.dataset.errors!=='true' && acknowledged && reservationReturn){
      const submitted=pending.items||[];
      items=read().map(x=>{const sent=submitted.find(y=>key(y)===key(x));return sent?{...x,qty:(+x.qty||1)-(+sent.qty||1)}:x}).filter(x=>x.qty>0);
      receipt={time:Date.now(),items:submitted};
      save(items); try{localStorage.setItem(RECEIPT,JSON.stringify(receipt));sessionStorage.removeItem(PENDING)}catch(_){}
      try{const url=new URL(location.href);url.searchParams.delete('reservation_submitted');url.searchParams.delete('customer_posted');history.replaceState(history.state,'',url.pathname+url.search+url.hash)}catch(_){}
      render(); open();
    } else {
      const ok=$('[data-res-success]',d), wrap=$('[data-res-form-wrap]',d);
      if(ok)ok.hidden=true; if(wrap)wrap.hidden=false;
      if(d.dataset.errors==='true' && reservationReturn)open();
    }
    showReceipt();
    const f=$('#px-reservation-form');
    f&&f.addEventListener('submit',e=>{
      if(!items.length){e.preventDefault();return}
      if(!submissionId)submissionId=Date.now().toString(36)+Math.random().toString(36).slice(2,7);
      try{sessionStorage.setItem(PENDING,JSON.stringify({time:Date.now(),items}))}catch(_){}
      const tag=$('[data-res-tags]',f), summary=$('[data-res-summary-field]',f), log=$('[data-res-log]');
      if(tag)tag.value=tags();
      if(summary)summary.value=items.map(x=>`${x.name} | ${x.logo||'Standard'} | ${x.color} | ${x.size} | Qty ${x.qty} | ${money((+x.price||0)*(+x.qty||1))}`).join(' ; ');
      if(log){
        const first=$('[name="contact[first_name]"]',f), last=$('[name="contact[last_name]"]',f), email=$('[name="contact[email]"]',f);
        const lf=$('[data-log-first]',log),ll=$('[data-log-last]',log),le=$('[data-log-email]',log),lb=$('[data-log-body]',log);
        if(lf)lf.value=first?first.value:''; if(ll)ll.value=last?last.value:''; if(le)le.value=email?email.value:'';
        if(lb)lb.value='PHOENX LAUNCH RESERVATION\n\n'+items.map(x=>`${x.name} | ${x.logo||'Standard'} | ${x.color} | ${x.size} | Qty ${x.qty}`).join('\n')+'\n\nEstimated total: '+money(total())+'\nNo payment taken.';
        try{fetch(log.action,{method:'POST',body:new FormData(log),credentials:'same-origin',keepalive:true}).catch(()=>{})}catch(_){}
      }
    });
  }
})();


